import React from "react";
import styles from '../../static/css/pages.module.css';

class PageLoading extends React.Component {
  render() {
    return (
      <div className={styles.pageLoading}>
        <div className={styles.loadingEl}>
          <div className={styles.loader}></div>
          Идёт загрузка...
        </div>
      </div>
    )
  }
}

export default PageLoading;